import { render } from "./PAvoidFraud.vue?vue&type=template&id=7075e3a5&scoped=true"
import script from "./PAvoidFraud.vue?vue&type=script&lang=js"
export * from "./PAvoidFraud.vue?vue&type=script&lang=js"

import "./PAvoidFraud.vue?vue&type=style&index=0&id=7075e3a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7075e3a5"]])

export default __exports__